import actions from '@/features/auth/store/auth.store.actions'
import getters from '@/features/auth/store/auth.store.getters'
import mutations from '@/features/auth/store/auth.store.mutations'

export interface IAuthData {
  token: string
  expiresAt: number
}
export interface IUser {
  id: number
  uuid: string
  role: string
  name: string
  customerId?: string
  isAgentUser?: boolean
}
export interface ICustomer {
  id: string
  name: string
  vertical: string
}

export interface ICustomerOption extends ICustomer {
  label: string
  value: string
}

export interface IAuthStore extends IAuthData {
  user: IUser
  customers?: ICustomer[]
  selectedCustomer?: ICustomer
}

export interface ICredentials {
  username: string
  password: string
}

export const state: IAuthStore = {
  token: '',
  expiresAt: 0,
  user: {} as IUser,
  customers: [],
  selectedCustomer: {} as ICustomer
}

export default {
  state: { ...state },
  actions,
  getters,
  mutations
}
